var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39848 15.8151H4.65848C2.28848 15.8151 1.50098 14.2401 1.50098 12.6576V6.34256C1.50098 3.97256 2.28848 3.18506 4.65848 3.18506H9.39848C11.7685 3.18506 12.556 3.97256 12.556 6.34256V12.6576C12.556 15.0276 11.761 15.8151 9.39848 15.8151Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.639 13.3251L12.554 11.8626V7.1301L14.639 5.6676C15.659 4.9551 16.499 5.3901 16.499 6.6426V12.3576C16.499 13.6101 15.659 14.0451 14.639 13.3251ZM8.62402 8.7501C8.92239 8.7501 9.20854 8.63157 9.41952 8.42059C9.6305 8.20962 9.74902 7.92347 9.74902 7.6251C9.74902 7.32673 9.6305 7.04058 9.41952 6.8296C9.20854 6.61863 8.92239 6.5001 8.62402 6.5001C8.32565 6.5001 8.03951 6.61863 7.82853 6.8296C7.61755 7.04058 7.49902 7.32673 7.49902 7.6251C7.49902 7.92347 7.61755 8.20962 7.82853 8.42059C8.03951 8.63157 8.32565 8.7501 8.62402 8.7501Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5a8d42815330270781421dae00db6cb4.svg";
export { ForwardRef as ReactComponent };